<template>
  <v-app class="image" :style="{ 'background-image': 'url(' + image + ')' }">
    <div class="login">
      <div class="form">
        <h2 class="form__title">{{ loginTitle }}</h2>
        <div class="form__error" v-if="!closeWarning">
          <div class="error__message">
            <p>Usuário ou senha incorretos!</p>
            <span @click="closeWarning = !closeWarning">X</span>
          </div>
        </div>

        <div class="infosForm">
          <form>
            <div class="rows">
              <input
                type="text"
                placeholder="Informe seu CPF/CNPJ"
                v-model="cpfCnpj"
                required
              />
            </div>
            <div class="rows">
              <input
                type="text"
                placeholder="Informe seu usuário"
                v-model="user"
                required
              />
            </div>
            <div class="rows">
              <div class="form-groups">
                <input
                  :type="[showPassword ? 'text' : 'password']"
                  v-model="password"
                  placeholder="Informe sua nova senha"
                  required
                />
                <span
                  class="input-group-text"
                  @click="showPassword = !showPassword"
                >
                  <i
                    class="fa"
                    :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
            </div>
            <a
              class="form__button"
              href="javascript:void(0)"
              @click="recoverPassword(cpfCnpj, user, password)"
              >Recuperar</a
            >
            <a
              style="margin-top: 20px"
              class="form__button"
              href="/login"
              >Voltar</a
            >
          </form>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: "",
      password: "",
      cpfCnpj: "",
      closeWarning: false,
      showPassword: false,
      linkDaPagina: null,
      arraySalesChannel: [],
      salesChannelSelect: false,
      loginTitle: "Recuperação de Senha",
      image: null
    };
  },

  beforeCreate() {
    // Busca a imagem de Background
    axios.get(`https://www.leverosintegra.com.br/map/Api/SolarBanners`)
    .then(res => {
      this.image = res.data;
    })
    .catch(err => {
      alert(`Erro ao buscar imagem de fundo da página: ${err}`)
    })
  },

  async created() {
    this.linkDaPagina = window.location.href;
  },

  metaInfo() {
    return {
      title: "Recuperação de Senha | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "Acesse sua conta no Leveros Integra para vender e comprar, além de acesso a área restrita.",
        },
        { name: "robots", content: "index,follow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: "Recuperação de Senha | Leveros Integra",
        },
        {
          property: "og:description",
          content:
            "Acesse sua conta no Leveros Integra para vender e comprar, além de acesso a área restrita.",
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
  methods: {
    recoverPassword(cpfCnpj, user, password) {
      if (cpfCnpj, user, password) {
        // Envia requisição de recuperação de senha
        axios({
          method: "post",
          data: {
            cpfCnpj,
            user,
            password
          },
          url: `https://www.leverosintegra.com.br/map/Api/Authentication`,
        }).then((res) => {
          if (res && res.data && res.data.status) {
            if (res.data.status === "ok") {
              window.location = "/login?Recuperacao=success";
            } else {
              alert('Erro ao enviar e-mail! Verifique os campos e tente novamente!')
            }
          }
        })
        .catch((err) => {
          alert('Erro ao enviar e-mail! Verifique os campos e tente novamente!')
          console.log(err)
        });
      } else {
        alert("Ops... \nPreencha todos os campos para continuar!")
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.image {
  // background: url("../assets/loginBackgroung.png")
  // no-repeat center center fixed;
  width: 100%;
  height: 100%;
  background-size: cover;
  position: absolute;
  top: auto;
}
.login {
  .image {
    width: 100%;
    height: 100%;
    background-size: cover;
    position: absolute;
    top: 0;
    z-index: -1;
  }

  .form {
    width: 30%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px;
    color: var(--customGray-500);
    background: var(--customWhite);
    border-radius: 5px;

    @media (max-width: 440px) {
      width: 90%;
    }

    &__title {
      color: var(--standardGreen);
      border-bottom: 1px solid var(--customGray-100);
      padding: 5px 0;
      font: 800 1.3rem "Soleto", sans-serif;
      margin-bottom: 15px;
    }

    &__error {
      display: none;

      .error {
        &__message {
          background: #ff000085;
          color: var(--customWhite);
          border-radius: 5px;
          padding: 5px !important;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          font-size: 0.95rem;

          p {
            padding: 0;
            font-weight: bold;
          }

          span {
            cursor: pointer;
            font-weight: bold;
          }
        }
      }
    }

    label {
      padding: 0 0 5px 0;
      font-weight: bold;

      span {
        font: 500 0.95rem "Soleto", sans-serif;
      }
    }

    input {
      border-bottom: 1px solid var(--standardGreen);
      padding: 10px 0;
      width: 100%;
      font-size: 0.95rem;
      outline: none;

      &:focus {
        border-bottom: 2px solid var(--standardGreen);
      }

      &:-webkit-autofill {
        box-shadow: 0 0 0 30px white inset;
      }
    }

    &__button {
      background: var(--standardGreen);
      border-radius: 5px;
      color: var(--customWhite);
      padding: 10px;
      text-decoration: none;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font: 700 1.1rem "Soleto", sans-serif;
      letter-spacing: 0.8px;
    }

    &__options {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 30px;

      p {
        font-size: 0.95rem;

        a {
          font-weight: bold;
          color: var(--standardGreen);
          text-decoration: none;
          font-size: 0.95rem;
        }
      }
    }
  }

  .channel {
    select {
      outline: none;
      margin-bottom: 15px;
    }
  }
}

.rows {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
}

.form-groups {
  display: flex;
  align-items: center;
}

.input-group-text {
  position: absolute;
  right: 50px;
}

.input {
  border: 1px solid #a1a1a1;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  font-size: 0.875rem;
}
</style>